import React from 'react';
import PageWithTitle from "../../../components/pages/pageWithTitle";
import localStrings from "../../../localStrings";
import useAuth from "../../../hooks/useAuth";
import Results from "./Results";

function  StaffData() {

    const {loading} = useAuth();
    return (
        <PageWithTitle title={localStrings.staffs}>
            <Results/>
        </PageWithTitle>

    )
}

export default  StaffData